var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _mask, _path5, _circle4, _circle5, _path6, _path7, _path8, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path9, _path10, _path11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 35,
    viewBox: "0 0 60 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2225 14.9403L37.8008 14.8993",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.13431,
    cy: 2.13431,
    r: 1.28814,
    transform: "matrix(-1 0 0 1 40.9612 12.8058)",
    fill: "white",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.86752,
    cy: 1.86752,
    r: 1.02136,
    transform: "matrix(-1 0 0 1 37.226 17.0743)",
    fill: "white",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.86752,
    cy: 1.86752,
    r: 1.02136,
    transform: "matrix(-1 0 0 1 37.226 9.0708)",
    fill: "white",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2223 11.2051H34.5581",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2223 19.2089L34.5581 19.2089",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3966 4.31246L30.2895 0.533569V30.4139L27.6217 32.0147L25.4873 27.4793L20.6407 23.2872L15.3494 14.0746L21.3966 4.31246Z",
    fill: "#F87609"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_156_1078",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6357 27.8178C35.682 27.7804 35.7331 27.7493 35.7874 27.7249C40.8314 25.456 44.3435 20.3867 44.3435 14.4971C44.3435 6.49056 37.853 0 29.8464 0C21.8399 0 15.3494 6.49056 15.3494 14.4971C15.3494 20.9501 19.5655 26.4183 25.3934 28.2974C25.6838 28.3911 25.8862 28.6588 25.8835 28.9639L25.8348 34.3155C25.8296 34.8875 26.4923 35.2077 26.9372 34.8481L35.6357 27.8178Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8348 34.3155L28.5424 34.3401L25.8348 34.3155ZM26.9372 34.8481L25.2352 32.7422L26.9372 34.8481ZM25.3934 28.2974L24.5625 30.8745L25.3934 28.2974ZM25.8835 28.9639L23.1758 28.9392L25.8835 28.9639ZM35.7874 27.7249L34.6766 25.2555L35.7874 27.7249ZM35.6357 27.8178L33.9337 25.7119L35.6357 27.8178ZM41.6358 14.4971C41.6358 19.2824 38.7844 23.4077 34.6766 25.2555L36.8982 30.1943C42.8785 27.5042 47.0513 21.4909 47.0513 14.4971H41.6358ZM29.8464 2.70773C36.3575 2.70773 41.6358 7.986 41.6358 14.4971H47.0513C47.0513 4.99512 39.3484 -2.70773 29.8464 -2.70773V2.70773ZM18.0571 14.4971C18.0571 7.986 23.3354 2.70773 29.8464 2.70773V-2.70773C20.3445 -2.70773 12.6416 4.99512 12.6416 14.4971H18.0571ZM26.2244 25.7203C21.4823 24.1913 18.0571 19.7407 18.0571 14.4971H12.6416C12.6416 22.1595 17.6488 28.6453 24.5625 30.8745L26.2244 25.7203ZM28.5424 34.3401L28.5911 28.9885L23.1758 28.9392L23.1272 34.2908L28.5424 34.3401ZM33.9337 25.7119L25.2352 32.7422L28.6392 36.954L37.3378 29.9237L33.9337 25.7119ZM23.1272 34.2908C23.1011 37.151 26.4147 38.752 28.6392 36.954L25.2352 32.7422C26.5699 31.6634 28.558 32.624 28.5424 34.3401L23.1272 34.2908ZM24.5625 30.8745C23.7814 30.6226 23.1673 29.876 23.1758 28.9392L28.5911 28.9885C28.6051 27.4415 27.5863 26.1595 26.2244 25.7203L24.5625 30.8745ZM34.6766 25.2555C34.4187 25.3715 34.1675 25.5229 33.9337 25.7119L37.3378 29.9237C37.1965 30.0379 37.0476 30.1271 36.8982 30.1943L34.6766 25.2555Z",
    fill: "#0073CB",
    mask: "url(#path-8-inside-1_156_1078)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.687,
    cy: 14.6734,
    r: 2.59621,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6872,
    cy: 14.6734,
    r: 2.34935,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.883 14.9404H4.67786",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6067 18.2239H12.0247L9.39783 20.194",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6067 11.6567H12.0247L9.39783 9.6866",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.41287,
    cy: 8.70144,
    r: 1.96002,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.41281,
    cy: 8.70163,
    r: 2.06017,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.77481,
    cy: 14.6118,
    r: 1.96002,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.77475,
    cy: 14.6122,
    r: 2.06017,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.41287,
    cy: 21.1789,
    r: 1.96002,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.41281,
    cy: 21.179,
    r: 2.06017,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2856 14.9404H55.4907",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.562 18.2239H48.144L50.7709 20.194",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.562 11.6567H48.144L50.7709 9.6866",
    stroke: "#0073CB",
    strokeWidth: 1.69233
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29849,
    cy: 2.29849,
    r: 1.96002,
    transform: "matrix(-1 0 0 1 54.0543 6.40295)",
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.04477,
    cy: 1.04477,
    r: 2.06017,
    transform: "matrix(-1 0 0 1 52.8005 7.65686)",
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29849,
    cy: 2.29849,
    r: 1.96002,
    transform: "matrix(-1 0 0 1 58.6925 12.3134)",
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.04477,
    cy: 1.04477,
    r: 2.06017,
    transform: "matrix(-1 0 0 1 57.4387 13.5674)",
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29849,
    cy: 2.29849,
    r: 1.96002,
    transform: "matrix(-1 0 0 1 54.0543 18.8804)",
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 0.676934
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.04477,
    cy: 1.04477,
    r: 2.06017,
    transform: "matrix(-1 0 0 1 52.8005 20.1343)",
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 2.0308
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconBackground);
export default __webpack_public_path__ + "static/media/Menu Icon Background.ab628d529f0c52bdbcb4b6e193ca4ab1.svg";
export { ForwardRef as ReactComponent };